var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_8038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6508 18.6397C26.3147 18.6397 29.2848 14.5348 29.2848 9.471C29.2848 4.40724 26.3147 0.302246 22.6508 0.302246C18.987 0.302246 16.0168 4.40724 16.0168 9.471C16.0168 14.5348 18.987 18.6397 22.6508 18.6397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5432 18.2535C46.692 18.3098 43.6357 21.9735 43.722 27.6473C43.8045 33.321 46.992 35.9048 50.8432 35.8485C54.6907 35.7923 57.747 33.1148 57.6645 27.441C57.5557 20.0535 51.4657 18.2385 50.5432 18.2535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8354 32.4138C13.6042 32.1501 16.3701 27.8007 16.0132 22.6992C15.6562 17.5977 12.3116 13.6758 8.5428 13.9395C4.77398 14.2032 2.00811 18.5526 2.36505 23.6541C2.72199 28.7556 6.06659 32.6775 9.8354 32.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0184 39.5535C43.7221 36.6548 40.9246 34.296 36.5521 28.2173C34.3846 25.2135 31.8909 24.8273 29.2809 24.8273C26.6671 24.8273 23.9146 25.746 21.7996 28.7835C19.6846 31.821 17.2846 34.791 12.6234 38.6798C7.96587 42.5685 5.98962 45.2535 5.98962 49.2098C5.98962 53.166 8.24712 59.7398 14.6709 59.7398C21.0946 59.7398 24.1996 58.326 29.2809 58.326C34.3621 58.326 37.7484 60.3023 44.1721 60.3023C50.5959 60.3023 53.2771 54.2235 53.2771 50.2673C53.2771 46.311 52.1634 44.0685 47.0184 39.5535Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1281_8038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4836 6.35473L47.4533 6.34187C45.2275 5.39709 43.2917 6.49773 42.2469 7.3557C42.1282 6.00382 41.5854 3.85109 39.3596 2.90631L39.3192 2.88915C36.9027 1.8873 34.0241 3.0892 32.799 5.63779C31.2945 8.76022 32.9271 11.9845 35.3569 16.8367C35.774 17.6824 36.2187 18.5757 36.6867 19.5266L36.8961 19.9617L37.3545 19.81C38.3535 19.4818 39.3151 19.1855 40.2132 18.8981C45.3914 17.2753 48.8447 16.2098 50.0456 12.9585C51.0278 10.3068 49.8829 7.39705 47.4836 6.35473Z",
    fill: "#FF3636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0455 12.9586C48.8446 16.2099 45.3913 17.2753 40.2131 18.8981C39.3149 19.1855 38.3533 19.4819 37.3544 19.8101L36.896 19.9617L42.2469 7.35576C43.2917 6.49776 45.2274 5.39715 47.4532 6.34193L47.4835 6.35479C49.8829 7.39712 51.0278 10.3069 50.0455 12.9586Z",
    fill: "#F40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_8038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.302246)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1281_8038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 18.75,
    fill: "white",
    transform: "translate(35.1844) rotate(23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWh);
export default __webpack_public_path__ + "static/media/logo-wh.e7726669e50086c5a91b5df13edb82af.svg";
export { ForwardRef as ReactComponent };